import React, { useContext, type FC, type ReactNode, useState, useCallback } from 'react';

const RefreshContext = React.createContext<{
  refreshTime: number;
  updateRefresh: (delayMs?: number) => void;
}>({
  refreshTime: 0,
  updateRefresh: () => {},
});

export const useRefreshTime = () => {
  return useContext(RefreshContext);
};

export const RefreshProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [currentTime, setCurrentTime] = useState(0);

  const update = useCallback((delayMs: number = 0) => {
    const timer = setTimeout(() => {
      setCurrentTime(Date.now());
      clearTimeout(timer);
    }, delayMs);
  }, []);

  return (
    <RefreshContext.Provider
      value={{
        refreshTime: currentTime,
        updateRefresh: update,
      }}
    >
      {children}
    </RefreshContext.Provider>
  );
};
